<template>
  <div>
    <!-- <Corporate /> -->
    <BookingTable />
    <!-- <EditBooking /> -->
  </div>
</template>

<script>
import Corporate from "./components/Corporate";
import BookingTable from "./components/BookingTable.vue";
import EditBooking from "./components/EditBooking.vue";

export default {
  components: {
    Corporate,
    BookingTable,
    // EditBooking,
  },
};
</script>
